var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNcxAmbassadorArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.284315 0.188583C-0.253996 0.576593 -0.0784596 0.916102 1.51307 2.7349C2.32053 3.65642 3.70142 5.23272 4.55569 6.21487L6.12382 8.00941L5.03549 9.2462C4.43867 9.92521 3.75993 10.7012 3.52588 10.968C3.29183 11.2347 2.40245 12.2412 1.55988 13.2112C0.389637 14.545 0.0268621 15.0421 0.0268621 15.2967C0.0268621 15.6362 0.389637 16 0.740709 16C1.10348 16 7.63343 8.49443 7.63343 8.07004C7.63343 7.91241 7.493 7.59715 7.31746 7.36677C6.56851 6.39675 1.05667 0.127956 0.89284 0.0673294C0.635387 -0.0417976 0.576875 -0.0296726 0.284315 0.188583Z",
    fill: "#B4B7BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64222 0.188588C8.47838 0.297716 8.38477 0.491721 8.38477 0.697851C8.39647 1.03736 8.67733 1.37687 12.8668 6.16637L14.4817 8.00942L13.4519 9.18557C12.3285 10.4709 9.07521 14.1812 8.65392 14.6662C8.30285 15.0542 8.30285 15.5635 8.64222 15.806C8.78265 15.9151 8.99329 16 9.09861 16C9.29755 16 10.222 14.9936 13.803 10.8831C15.5934 8.82181 15.9913 8.30042 15.9913 8.00942C15.9913 7.71841 15.4998 7.08789 13.2179 4.4567C9.0401 -0.344927 9.18053 -0.211548 8.64222 0.188588Z",
    fill: "#B4B7BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcxAmbassadorArrow);
export default __webpack_public_path__ + "static/media/ncx-ambassador_arrow.7a5623879c3b3f9bfdf263ba2c44b73a.svg";
export { ForwardRef as ReactComponent };